module.exports = __webpack_public_path__ + "static/media/avtar.b2b55e72.png";